'use client'

import React from 'react'

import type {LoginBeginData, LoginFormData} from '@/src/features/auth/core/login-types'
import {useLoginFormSubmit} from '@/src/features/auth/model/use-login-form-submit'
import {LoginForm} from '@/src/features/auth/ui/login-form'
import {OAuthPageContent} from '@/src/features/auth/core/oauth-types'
import {ThirdPartyContainer} from '@/src/features/auth/containers/third-party-providers'

type LoginFormContainerProps = {
  onNext: (props: LoginBeginData & {phone: string}) => void
  onSubmitAction: (data: LoginFormData, captchaToken: string) => Promise<(LoginBeginData & {phone: string}) | null>
  thirdPartyProviders: OAuthPageContent['oauth_providers']
  loading: boolean
}

export const LoginFormContainer = ({onNext, onSubmitAction, thirdPartyProviders, loading}: LoginFormContainerProps) => {
  const {onSubmit, isTokenReady, captchaProps} = useLoginFormSubmit({onSubmitAction, onNext})

  return (
    <LoginForm
      loading={loading}
      isTokenReady={isTokenReady}
      onSubmit={onSubmit}
      captchaProps={captchaProps}
      providers={<ThirdPartyContainer providers={thirdPartyProviders} />}
    />
  )
}
